export default function and(a, b) {
  return Boolean(a && b);
}
